<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="item.isOpen"
      :controlled="true"
      :has-toggle="false"
      :border-color="item.statusColor"
    >
      <div class="row py-3 m-0">
        <div class="col-md-1 col-12 col-spacing student-spacing">
          <div class="border-right py-3">
            <custom-balloon
              :background-color="item.statusColor"
              class="mt-2"
              :text="item.statusName"
              dot
            />
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre de Equipo MiPE:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.name | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Categoría en Catálogo de Cumplimiento:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.classification.name | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Última Fecha de Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.lastDate | date }}
          </div>
        </div>
        <div class="col">
          <drop-down
            :items="actionItems"
            :always-show-dropdown="true"
            class="float-md-right mr-5"
          />
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';

export default {
  name: 'InventoryResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    actionItems() {
      return [
        {
          name: 'Administrar Inventario',
          icon: 'fas fa-list text-success',
          click: () => this.goToManagement(),
        },
        // {
        //   name: 'Informacion Adicional',
        //   icon: 'fas fa-info-circle text-success',
        // },
        // {
        //   name: 'Editar Equipo',
        //   icon: 'fas fa-edit text-success',
        // },
        // {
        //   name: 'Inactivar',
        //   icon: 'fas fa-ban text-muted',
        // },
      ];
    },
  },
  methods: {
    goToManagement() {
      this.$router.push({
        name: 'inventoryManagement',
        params: {
          id: this.item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss"></style>
